// src/modalBridge.ts
let openFn: ((opts?: { expiresAt?: string }) => void) | null = null;

export const registerOpenCortesia = (
  fn: (opts?: { expiresAt?: string }) => void
) => {
  openFn = fn;
};

export const openCortesiaModal = (opts?: { expiresAt?: string }) => {
  openFn?.(opts);
};
